import { Alert, Box, Paper, Typography } from '@mui/material';

function DashboardChartCard({
  title,
  children,
  isEmpty,
  emptyMessage,
  chartFrameClassName = '',
  chartFrameStyle = undefined,
  cardClassName = '',
  action = null,
}) {
  return (
    <Paper className={`dashboard-chart-card ${cardClassName}`} elevation={1}>
      <Box className="dashboard-chart-card-header">
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        {action}
      </Box>
      {isEmpty ? (
        <Alert severity="info" className="dashboard-chart-empty">
          {emptyMessage}
        </Alert>
      ) : (
        <Box className={`dashboard-chart-frame ${chartFrameClassName}`} style={chartFrameStyle}>
          {children}
        </Box>
      )}
    </Paper>
  );
}

export default DashboardChartCard;
